import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';

//import images
import avatar1 from "../../assets/images/users/user-dummy-img.jpg";
import { useTranslation } from 'react-i18next';
import {authUserManager} from "../../helpers/api_helper";

const ProfileDropdown = () => {
    const { t } = useTranslation();
    const { eventId } = useParams();
    const isClubAdmin = authUserManager.isClubAdmin();

    const profileDropdownData = createSelector(
        (state) => state.Profile,
        (slice) => ({user: slice.user})
      );
    const {user} = useSelector(profileDropdownData);


      const profileAdminDropdownData = createSelector(
        (state) => state.AdminProfile,
        (slice) => ({ adminUser: slice.user })
      );
      let { adminUser } = useSelector(profileAdminDropdownData);

    const eventSelector = createSelector(
      (state) => state.Event,
      (slice) => slice.event.startAt
    );
    const eventStartAt = useSelector(eventSelector)

    const [userName, setUserName] = useState();

  useEffect(() => {
    if (isClubAdmin) {
      const authUser = authUserManager.getAuthUser();
      setUserName(authUser.username?.split(' ')[0] || authUser.username || 'User');
    } else if (authUserManager.isEventGuest(eventId, eventStartAt)) {
      setUserName(authUserManager.getGuest().username?.split(' ')[0] || authUserManager.getGuest().username || 'User' );
    }

  }, [user, eventStartAt, adminUser]);

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown} className="ms-sm-3 header-item topbar-user">
              <DropdownToggle tag="button" type="button" className="btn ps-2 pe-2 pb-1 position-relative" style={{cursor: isClubAdmin ? 'pointer' : 'default'}}>
    <span className="d-flex flex-column align-items-center">
        <div className="position-relative">
            <img className="rounded-circle header-profile-user" src={avatar1} alt="Header Avatar"/>
          {isClubAdmin && (
            <div
              className="position-absolute d-flex align-items-center justify-content-center rounded-circle bg-light border border-2 border-white"
              style={{
                bottom: '0',
                right: '0',
                width: '18px',
                height: '18px',
                transform: 'translate(25%, 25%)'
              }}
            >
              <i className="mdi mdi-chevron-down"></i>
            </div>
          )}
        </div>
      {!isClubAdmin && <span className="text-center pt-125 fs-10">
              <span className="d-block fw-medium user-name-text">{userName ?? t('Guest')}</span>
          </span>}
    </span>
              </DropdownToggle>
              {isClubAdmin && <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">{t('Welcome')} {userName}!</h6>
                <DropdownItem className='p-0'>
                  <Link to="/admin/profile" className="dropdown-item">
                    <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i> <span
                    className="align-middle">{t('Profile')}</span>
                  </Link>
                </DropdownItem>
                    <DropdownItem className='p-0'>
                      <Link to="/admin/song-libraries" className="dropdown-item">
                        <i className="mdi mdi-music-note text-muted fs-16 align-middle me-1"></i> <span
                        className="align-middle">{t('Song Libraries')}</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                      <Link to="/admin/tips" className="dropdown-item">
                        <i className="mdi mdi-account-cash-outline text-muted fs-16 align-middle me-1"></i> <span
                        className="align-middle">{t('Tips')}</span>
                      </Link>
                    </DropdownItem>
                    <DropdownItem className='p-0'>
                      <Link to= "/admin/help" className="dropdown-item">
                        <i
                          className="mdi mdi-help-circle-outline text-muted fs-16 align-middle me-1"></i> <span
                        className="align-middle">{t('Help')}</span>
                      </Link>
                    </DropdownItem>
                    <div className="dropdown-divider"></div>
                    <DropdownItem className='p-0'>
                        <Link to= "/admin/logout" className="dropdown-item">
                            <i
                                className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle" data-key="t-logout">{t('Logout')}</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
              }
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;
